/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataFromJSON, FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataToJSON, } from './FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorData';
import { FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSON, FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSON, } from './FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessData';
/**
 * Check if a given object implements the FxIdApplicationStoreYandexGamesYandexBonusResultData interface.
 */
export function instanceOfFxIdApplicationStoreYandexGamesYandexBonusResultData(value) {
    return true;
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SucccessData': json['SucccessData'] == null ? undefined : FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSON(json['SucccessData']),
        'ErrorData': json['ErrorData'] == null ? undefined : FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataFromJSON(json['ErrorData']),
    };
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SucccessData': FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSON(value['SucccessData']),
        'ErrorData': FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataToJSON(value['ErrorData']),
    };
}
//# sourceMappingURL=FxIdApplicationStoreYandexGamesYandexBonusResultData.js.map